/* Decorner cart delivery-ZIP gate — GLOBAL persistent module.
   Rendered ONCE in layout/theme.liquid, OUTSIDE any Section-Rendering-API
   region, so this script stays alive across cart-drawer AJAX refreshes.

   The gate's MARKUP (snippets/dc-delivery-gate.liquid) still renders inside
   cart-summary.liquid every time -- it needs real Liquid state (the contact
   form's posted_successfully?/errors) and correct DOM position ahead of the
   checkout button for the CSS sibling rule below. What used to break was
   binding logic directly to that markup's own inline <script>: every cart
   AJAX refresh (adding White Glove, changing quantity, etc.) replaces that
   HTML wholesale, and a freshly-injected <script> tag never re-executes, so
   the "Check" button silently stopped doing anything and any previously
   "approved" ZIP state was lost -- checkout stayed hidden forever.

   Fix: bind once, at the document level, and re-resolve the live gate
   elements on every interaction instead of caching references to nodes that
   may since have been thrown away. */
(function () {
  var SS_ZIP = 'dc_delivery_zip';
  var SS_STATUS = 'dc_delivery_status'; // 'approved' | 'denied'
  var APPROVED_CLASS = 'dc-delivery-approved';

  function getRoot() {
    return document.querySelector('[data-dc-gate]');
  }

  function setApproved(approved) {
    document.body.classList.toggle(APPROVED_CLASS, !!approved);
  }

  function broadcastStatus(inArea, zip, zoneName) {
    try {
      document.dispatchEvent(new CustomEvent('dc:delivery-status', {
        detail: { inArea: !!inArea, zip: zip || null, zone: zoneName || null }
      }));
    } catch (e) {}
  }

  function cartSummaryLine() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return cart.items.map(function (it) {
          return '- ' + it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : '') + ' x' + it.quantity;
        }).join('\n');
      })
      .catch(function () { return ''; });
  }

  function whenZonesReady(fn, attemptsLeft) {
    if (window.DecornerDeliveryZones) { fn(); return; }
    if (attemptsLeft == null) attemptsLeft = 40;
    if (attemptsLeft <= 0) return;
    setTimeout(function () { whenZonesReady(fn, attemptsLeft - 1); }, 50);
  }

  function applyResult(root, result, zip) {
    var quoteBox  = root.querySelector('[data-dc-gate-quote]');
    var msg       = root.querySelector('[data-dc-gate-msg]');
    var hiddenZip = root.querySelector('[data-dc-gate-hidden-zip]');
    var bodyField = root.querySelector('[data-dc-gate-body]');
    if (!quoteBox || !msg) return;

    if (result && result.inArea) {
      quoteBox.hidden = true;
      setApproved(true);
      msg.hidden = false;
      msg.textContent = 'Great -- we deliver to ' + zip + ' (' + result.zone + ').';
      try {
        sessionStorage.setItem(SS_ZIP, zip);
        sessionStorage.setItem(SS_STATUS, 'approved');
      } catch (e) {}
      broadcastStatus(true, zip, result.zone);
    } else {
      setApproved(false);
      msg.hidden = false;
      msg.textContent = "We don't currently have automated delivery pricing for " + zip + '.';
      quoteBox.hidden = false;
      if (hiddenZip) hiddenZip.value = zip;
      if (bodyField && !bodyField.value) {
        cartSummaryLine().then(function (lines) {
          bodyField.value = 'ZIP: ' + zip + '\n\nItems:\n' + (lines || '(cart empty)');
        });
      }
      try {
        sessionStorage.setItem(SS_ZIP, zip);
        sessionStorage.setItem(SS_STATUS, 'denied');
      } catch (e) {}
      broadcastStatus(false, zip, null);
    }
  }

  function runCheck(root, zipOverride) {
    var input = root.querySelector('[data-dc-gate-input]');
    var msg   = root.querySelector('[data-dc-gate-msg]');
    var zip   = (zipOverride != null ? zipOverride : (input ? input.value : '')) || '';
    zip = zip.trim();
    if (input) input.value = zip;
    if (!/^\d{5}$/.test(zip)) {
      if (msg) { msg.hidden = false; msg.textContent = 'Please enter a valid 5-digit ZIP code.'; }
      setApproved(false);
      return;
    }
    whenZonesReady(function () {
      var result = window.DecornerDeliveryZones ? window.DecornerDeliveryZones.check(zip) : null;
      applyResult(root, result, zip);
    });
  }

  // Re-sync whenever the gate markup (re)appears -- covers the first render
  // and every later cart-drawer/cart-page AJAX refresh, which swaps this
  // node's HTML out from under any handlers bound to the old one.
  var lastSyncedRoot = null;
  function syncIfNewRoot() {
    var root = getRoot();
    if (!root || root === lastSyncedRoot) return;
    lastSyncedRoot = root;

    var saved = null, status = null;
    try {
      saved = sessionStorage.getItem(SS_ZIP);
      status = sessionStorage.getItem(SS_STATUS);
    } catch (e) {}

    // Fall back to a ZIP already checked via the White Glove panel (shares
    // the same delivery zones) so the customer isn't asked to re-type it.
    if (!saved) {
      try { saved = localStorage.getItem('dc_wg_zip'); } catch (e) {}
    }

    if (saved && /^\d{5}$/.test(saved)) {
      var input = root.querySelector('[data-dc-gate-input]');
      if (input) input.value = saved;
      if (status === 'approved') {
        whenZonesReady(function () {
          var result = window.DecornerDeliveryZones ? window.DecornerDeliveryZones.check(saved) : null;
          applyResult(root, result, saved);
        });
      } else {
        // Unknown/denied status for a WG-sourced ZIP -- re-run the real
        // check rather than trusting a stale flag.
        runCheck(root, saved);
      }
    } else {
      setApproved(false);
      broadcastStatus(false, null, null);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dc-gate-submit]');
    if (!btn) return;
    var root = btn.closest('[data-dc-gate]');
    if (!root) return;
    runCheck(root);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-dc-gate-input]');
    if (!input) return;
    e.preventDefault();
    var root = input.closest('[data-dc-gate]');
    if (!root) return;
    runCheck(root);
  });

  // Fold the ZIP + cart contents into the quote form's message body right
  // before it submits (this is a real page POST via {% form 'contact' %},
  // not AJAX, so this only needs to run once per submit).
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.dc-delivery-gate__form');
    if (!form) return;
    var nameEl    = form.querySelector('[name="contact[name]"]');
    var emailEl   = form.querySelector('[name="contact[email]"]');
    var phoneEl   = form.querySelector('[name="contact[phone]"]');
    var addressEl = form.querySelector('[name="contact[address]"]');
    var hiddenZip = form.querySelector('[data-dc-gate-hidden-zip]');
    var bodyField = form.querySelector('[data-dc-gate-body]');
    if (!bodyField) return;
    var zip = hiddenZip ? hiddenZip.value : '';
    var items = bodyField.value.split('\n\nItems:\n')[1] || bodyField.value;
    var lines = [
      'New Delivery Quote',
      'Name: ' + (nameEl ? nameEl.value : ''),
      'Email: ' + (emailEl ? emailEl.value : ''),
      'Phone: ' + (phoneEl && phoneEl.value ? phoneEl.value : '(not provided)'),
      'ZIP: ' + zip,
      'Delivery address: ' + (addressEl ? addressEl.value : ''),
      '',
      'Items:',
      items
    ];
    bodyField.value = lines.join('\n');
  });

  var moTimer = null;
  var mo = new MutationObserver(function () {
    if (moTimer) return;
    moTimer = setTimeout(function () { moTimer = null; syncIfNewRoot(); }, 60);
  });
  try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncIfNewRoot);
  } else {
    syncIfNewRoot();
  }
})();
